import jqRequest from '../jqRequest'
import raffleUrls from '../urls/raffle'

export default {
  // 获取抽奖详细
  findOneDrawRaffleById(data) {
    return jqRequest.requestWithToken(raffleUrls.findOneDrawRaffleById, data);
  },
  // 根据抽奖id 获得抽奖下面的所有奖项
  listAwardByDrawRaffleId(data) {
    return jqRequest.requestWithToken(raffleUrls.listAwardByDrawRaffleId, data);
  },
  // 获取剩余抽奖次数
  getDrawRaffleTimes(data) {
    return jqRequest.requestWithToken(raffleUrls.getDrawRaffleTimes, data);
  },
  // 抽奖(定时抽奖，即时抽奖)
  doDrawRaffle(data) {
    return jqRequest.requestWithToken(raffleUrls.doDrawRaffle, data);
  },
  // 获得我的及时抽奖中奖奖品
  listAwardLogsByMemberId(data) {
    return jqRequest.requestWithToken(raffleUrls.listAwardLogsByMemberId, data);
  },
  // 兑奖
  acceptPrize(data) {
    return jqRequest.requestWithToken(raffleUrls.acceptPrize, data);
  },
  // 保存奖品邮寄地址
  awardSaveExpressInfo(data) {
    return jqRequest.requestWithToken(raffleUrls.awardSaveExpressInfo, data);
  },
}